/* =========================================================================
   Skin Diligent — Achat rapide : afficher la page produit COMPLÈTE
   dans la fenêtre, au lieu de la seule fiche produit.

   Ajouté le 7 septembre 2026.
   Ce fichier intercepte le clic sur « Achat rapide » avant le thème
   (écoute en phase de capture) et refait le chargement lui-même.
   Le thème n'est pas modifié : pour revenir en arrière, il suffit de
   retirer les deux lignes sd-quickbuy-popup.css / .js de layout/theme.liquid.
   ========================================================================= */

(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cc-quick-buy]');
    if (!btn) return;

    // Si le thème n'est pas prêt, on ne touche à rien : comportement d'origine.
    if (!window.jQuery || !window.theme || !window.showThemeModal || !theme.quickBuy) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var productUrl = btn.getAttribute('href');
    var $ = window.jQuery;

    showThemeModal(
      '<div class="theme-modal theme-modal--fullscreen theme-modal--quickbuy -light js-quickbuy" id="quick-buy-modal" role="dialog" aria-modal="true">' +
        '<a href="#" data-modal-close class="modal-close">&times;</a>' +
        '<div class="theme-modal__loading">' + theme.icons.loading + '</div>' +
      '</div>',
      'quick-buy',
      null
    );

    if (theme.currentQuickbuyRequest) theme.currentQuickbuyRequest.abort();

    theme.currentQuickbuyRequest = $.get(productUrl, function (response) {
      var $modal = $('#quick-buy-modal');
      var tmpl = document.createElement('template');
      tmpl.innerHTML = response;

      var srcMain = tmpl.content.querySelector('#page-content');
      if (!srcMain) { window.location = productUrl; return; }

      // On reprend tout le contenu de la page produit
      var wrapper = document.createElement('div');
      wrapper.className = 'sd-quickbuy-full';
      while (srcMain.firstChild) wrapper.appendChild(srcMain.firstChild);

      var sidebar = wrapper.querySelector('.faq-sidebar');
      if (sidebar) sidebar.remove();

      // On garde les éléments que l'achat rapide masquait (accordéons, avis, etc.)
      wrapper.querySelectorAll('[data-show-in-quickbuy]').forEach(function (el) {
        el.removeAttribute('data-show-in-quickbuy');
      });

      // Préparation du thème : suffixage des id, des labels, des radios…
      theme.quickBuy.convertToQuickBuyContent(wrapper, productUrl);

      $modal.find('.theme-modal__loading')[0].replaceWith(wrapper);

      var section = wrapper.querySelector('[data-section-type="product-template"]');

      theme.initAnimateOnScroll();
      if (section) theme.ProductTemplateSection.onSectionLoad(section, true);
      theme.initComponents($modal);
      theme.initShopifyPaymentButtons($modal);

      // Avis Stamped : le widget de la fenêtre doit porter l'id attendu par
      // l'app, on le cède le temps de l'ouverture puis on le rend à la page.
      var bgWidget = document.querySelector('#page-content #stamped-main-widget');
      var modalWidget = wrapper.querySelector('#stamped-main-widget-qb');
      if (bgWidget) bgWidget.id = 'stamped-main-widget-bg';
      if (modalWidget) modalWidget.id = 'stamped-main-widget';
      if (window.StampedFn) {
        try { StampedFn.loadBadges(); } catch (err) {}
        try { StampedFn.reloadUGC(); } catch (err) {}
      }

      $(window).one('ccModalClosing', function () {
        if (modalWidget) modalWidget.id = 'stamped-main-widget-qb';
        if (bgWidget) bgWidget.id = 'stamped-main-widget';
        if (section) theme.ProductTemplateSection.onSectionUnload(section, true);
      });
    })
    .fail(function (xhr) {
      // Chargement impossible : on envoie sur la page produit, comme avant.
      if (xhr && xhr.statusText === 'abort') return;
      window.location = productUrl;
    })
    .always(function () {
      theme.currentQuickbuyRequest = false;
    });
  }, true);
})();
